export default {
  path: '/companies',
  component: () => import('../layouts/Dashboard/Index.vue'),
  children: [
    {
      path: '',
      name: 'company',
      component: () => import('../views/Company/PageList.vue'),
    },
    {
      path: '/company/:companyId',
      props: true,
      component: () => import('../views/Company/Show/PageShow.vue'),
      children: [
        {
          path: 'summary',
          name: 'company show',
          component: () =>
            import('../views/Company/Show/Summary/PageSummary.vue'),
        },
        {
          path: 'members',
          name: 'company show members',
          component: () => import('../views/Company/Show/PageMembers.vue'),
        },
      ],
    },
  ],
}
